import en from './en.json'
import de from './de.json'
// import moment from 'moment'
import 'moment/locale/de'
// import { addLocaleData } from 'react-intl'
// import deData from 'react-intl/locale-data/de'

export const locales = {
  en,
  de,
};

export const defaultLocale = 'de'
// moment.locale(defaultLocale)

// addLocaleData([...deData])
